import { LimitsReponse, RemainingLimitsParams } from "@letsbit/malcolmlb";
import { useContext } from "react";
import { Key, SWRResponse } from "swr";

import { ApiContext } from "providers/ApiProvider";
import { useAuthSWR } from "hooks/utils/useAuthSWR";

export const SWR_GET_MEMBER_LIMITS = "get-member-limits";

export const getLimitsKey = (params: RemainingLimitsParams): Key => [
  SWR_GET_MEMBER_LIMITS,
  { ...params },
];

export const useGetLimits = (
  params?: RemainingLimitsParams,
): SWRResponse<LimitsReponse[], Error> => {
  const { memberInstance } = useContext(ApiContext);
  const swr = useAuthSWR(
    params ? getLimitsKey(params) : null,
    async ([, params]) => {
      const { data } = await memberInstance.payments.getLimits(params);
      return data;
    },
  );
  return swr;
};
